export default __webpack_public_path__ + "static/media/other_investment_light.647d23ad.png";